import { useAuth } from "../../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { getCarriers } from "../api/contactsApi";

const useCarriers = ({ enabled = false }) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();

  return useQuery({
    queryKey: ["carriers_contacts"],
    queryFn: async () => {
      const response = await getCarriers({ token });
      return response;
    },
    refetchOnWindowFocus: false,
    initialData: [],
    enabled: enabled,
  });
};

export default useCarriers;
